// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import React, { Component, createRef } from 'react';
import { Switcher } from '@front/sharedcomponents/Switcher/Switcher';
export class OvernightExecutionControl extends Component {
    constructor(props) {
        super(props);
        this._infoIconRef = createRef();
        this.onActiveChanged = () => {
            var _a, _b;
            const isActive = !this.props.isActive;
            (_b = (_a = this.props.events) === null || _a === void 0 ? void 0 : _a.onActiveChanged) === null || _b === void 0 ? void 0 : _b.call(_a, isActive);
        };
    }
    render() {
        const controlStyle = {};
        if (isValidNumber(this.props.controlWidth)) {
            controlStyle.width = controlStyle.minWidth = controlStyle.maxWidth = this.props.controlWidth;
        }
        return (React.createElement("div", { className: "overnight-execution" },
            React.createElement("div", { className: "overnight-execution-label" }, Resources.getResource(this.props.textKey)),
            React.createElement("div", { className: "overnight-execution-control", style: controlStyle },
                React.createElement("div", { className: "overnight-execution-control-info", ref: this._infoIconRef, onClick: () => {
                        showTooltip(this._infoIconRef.current, Resources.getResource(this.props.tooltipKey));
                    }, onPointerLeave: () => {
                        hideTooltip();
                    } },
                    React.createElement("svg", null,
                        React.createElement("use", { xlinkHref: "assets/webdesktop/web-desktop-sprite.svg#infoIcon" }))),
                React.createElement("div", { className: "overnight-execution-control-switcher" },
                    React.createElement(Switcher, { disabled: this.props.isEnabled === false, checked: this.props.isActive, onClick: this.onActiveChanged })))));
    }
}
